import React, { memo, useEffect } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  SelectProps as MuiSelectProps
} from '@mui/material';
import { LabelValue } from '../../types/common';

interface SelectProps extends MuiSelectProps {
  options: LabelValue[];
  formControlProps?: object;
  helperText?: string;
  maxWidth?: string | number;
  handleBlur?: any;
  onUnMountCallBack?: any;
  defaultValue?: any;
}

const Select: React.FC<SelectProps> = ({
  defaultValue = '',
  name,
  id,
  label,
  labelId,
  options,
  fullWidth,
  size,
  formControlProps,
  error,
  helperText,
  placeholder,
  maxWidth,
  className = '',
  onUnMountCallBack,
  handleBlur,
  ...restProps
}) => {
  useEffect(() => {
    return () => {
      if (onUnMountCallBack) {
        onUnMountCallBack();
      }
    };
  }, []);

  return <FormControl fullWidth={!!fullWidth} {...formControlProps}>
    <InputLabel id={labelId}>{label}</InputLabel>
    <MuiSelect
      defaultValue={defaultValue}
      name={name ?? ''}
      label={label}
      fullWidth={!!fullWidth}
      error={!!error}
      onBlur={handleBlur}
      {...restProps}
    >
      {options.map((option, index) => (
        <MenuItem key={index} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </MuiSelect>
    {error && <FormHelperText error={error}>{helperText}</FormHelperText>}
  </FormControl>;
};

export default memo(Select);
